export type CustomCurrencyCode = 'SAR' | 'AED';
export type Parts = Intl.NumberFormatPart[];

export const CUSTOM_CURRENCY_CODES: CustomCurrencyCode[] = ['SAR', 'AED'];
export const CUSTOM_CURRENCY_GLYPH = '\uE900';

export const normalizeParts = (parts: Parts) => {
  let currencySeen = false;

  return parts.reduce<Parts>((acc, part) => {
    if (part.type === 'currency') {
      currencySeen = true;
      return [...acc, part];
    }

    if (currencySeen && part.type === 'literal' && !part.value.trim()) {
      return acc;
    }

    return [...acc, part];
  }, []);
};

export const isCustomCurrencyCode = (code: string): code is CustomCurrencyCode =>
  CUSTOM_CURRENCY_CODES.includes(code as CustomCurrencyCode);

export const getRenderedCurrencySymbol = (currencyCode: string) => {
  if (isCustomCurrencyCode(currencyCode)) {
    return {
      glyph: CUSTOM_CURRENCY_GLYPH,
      className: `currency-symbol currency-symbol--${currencyCode}`,
    };
  }

  return {
    glyph: currencyCode,
  };
};
